import React, { Component } from 'react';
import { Provider } from "react-redux";

import Routes from './routes';
import Store from './store';

class App extends Component {
  render() {
    return (
      <div>
        <Provider store={Store}>
          <Routes />
        </Provider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js